export enum MarketingConsentStatus {
  Pending = 'Pending',
  Granted = 'Granted',
  Declined = 'Declined',
}
